import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

export default function Menu({ ...props }) {
  let content;
  if (props.isLoading) {
    content = <div className="p-3" name="loading">Searching...</div>;
  } else if (props.selectProps.inputValue) {
    if (props.options.length) {
      return <components.Menu {...props} />;
    } else {
      content = (
        <div className="p-3 text-center">
          No items found
        </div>
      );
    }
  } else {
    return null;
  }

  return <components.Menu {...props}>{content}</components.Menu>;
}

Menu.propTypes = {
  isLoading: PropTypes.bool,
  options: PropTypes.array.isRequired,
  recordType: PropTypes.string,
  selectProps: PropTypes.shape({
    inputValue: PropTypes.string
  })
};
